<template>
  <div></div>
</template>

<script>
import api from '@/api.js';
export default {
  name: "IndexView",
  methods: {
    // Obtener usuario por token
    async getUserByToken() {
      const token = localStorage.getItem("token");
      if (token) {
        // Verificar si el token es válido
        try {
          const response = await api.get(
            `/api/user/userLogin`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          console.log("Respuesta getUserByToken: ", response.data);
          return response.data;
        } catch (error) {
          console.error(error);
        }
      }
    },
  },
  async mounted() {
    // Obtener token
    const token = localStorage.getItem("token");
    if (token) {
      // Verificar si el token es válido
      try {
        const user = await this.getUserByToken();
        if (user) {
          this.$router.push("/home");
        } else {
          this.$router.push("/login");
        }
      } catch (error) {
        console.error(error);
      }
    } else {
      this.$router.push("/login");
    }
  },
};
</script>
